export default {
    pincodesList: []
}